module.exports = __webpack_public_path__ + "img/vipevent_type_icon@2x.d3f4e155.png";